import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import MEModal from '../../components/MEModal'

export const ArchiveConfirmModal = ({ archiveMembersModalOpen, toggleArchiveMembersModal, dispatchArchiveMembers }) => {
  return (
    <MEModal
      show={archiveMembersModalOpen}
      close={toggleArchiveMembersModal}
      title="Archive course members?"
    >
      <p>Are you sure you want to archive the selected course members?</p>
      <Button
        type="button"
        variant="danger"
        className="btn-myed btn-danger-myed mr-4"
        onClick={dispatchArchiveMembers}
      >
        Archive
      </Button>
      <Button
        type="button"
        variant="secondary"
        className="btn-myed btn-default-myed"
        onClick={toggleArchiveMembersModal}
      >
        Cancel
      </Button>
    </MEModal>
  )
}

ArchiveConfirmModal.propTypes = {
  archiveMembersModalOpen: PropTypes.bool,
  toggleArchiveMembersModal: PropTypes.func,
  dispatchArchiveMembers: PropTypes.func,
}
